import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { BaseMaintenanceController } from '../../_base/BaseMaintenanceController';
import { NotificationTopicSchemaUserListMaintenanceDto } from './NotificationTopicSchemaUserListMaintenanceDto';
import { NotificationTopicSchemaUserItemMaintenanceDto } from './NotificationTopicSchemaUserItemMaintenanceDto';

@Injectable()
export class NotificationTopicSchemaUserMaintenanceController extends BaseMaintenanceController<NotificationTopicSchemaUserListMaintenanceDto, NotificationTopicSchemaUserItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "system/notificationtopicschemauser");
    }

    public getResourceRoot(): string {
        return "NOTIFICATIONTOPICSCHEMAUSER";
    }
}